module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_enpgames_m.d2603422404ceac6ccec547021ab8719.png";